import { FORMAT_LABELS, FormatSchema, type Format } from '@ugin/shared';
import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { MetaShareWidget } from '@/widgets/meta-share';

export function Meta() {
  const { format } = useParams<{ format: string }>();
  const navigate = useNavigate();
  const currentFormat = useMemo<Format>(() => {
    const parsed = FormatSchema.safeParse(format);
    return parsed.success ? parsed.data : 'standard';
  }, [format]);

  return (
    <div className="space-y-6">
      <header className="space-y-1">
        <h1 className="font-display text-4xl tracking-wide text-ugin-text">Meta</h1>
        <p className="text-sm text-ugin-text-muted">
          The current shape of {FORMAT_LABELS[currentFormat]}, drawn from open public data.
        </p>
      </header>

      <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
        <MetaShareWidget
          format={currentFormat}
          onFormatChange={(f) => navigate(`/meta/${f}`)}
        />
      </div>
    </div>
  );
}
